import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Input, Select } from 'antd';

import { MultipleSelect } from '@app/components';
import { CLIENT_BALANCE_MAX } from '@app/constants';
import { PF } from '@app/pages/Warehouses/Products/data';
import type { FiltersType } from '@app/pages/Warehouses/Products/types';
import { getSelectedOptions } from '@app/pages/Warehouses/utils';
import { Range } from '@app/shared/components';

const FILTER = `${PF}_filters`;

export const Filters: FiltersType = ({
  onChange,
  skipFilters,
  onChangeSearchTerm,
  onSearch,
  unsavedFilters: {
    SearchTerm,
    CategoryIds,
    BrandIds,
    WarehouseId,
    PriceOfPurchaseE,
    PriceOfPurchaseS,
    PriceOfSaleE,
    PriceOfSaleS,
    IsAtMinimal,
    IsAtCritical,
  },
  disabled = false,
  categoryOptions,
  brandsOptions,
  warehousesOptions,
}) => (
  <div className={`${FILTER}_container`}>
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите название, штрихкод или артикул товара"
      value={SearchTerm ?? ''}
      onChange={onChangeSearchTerm}
      className={`${FILTER}_search`}
      disabled={disabled}
      onPressEnter={onSearch}
    />
    <MultipleSelect
      className={`${FILTER}_select`}
      placeholder="Все категории"
      allOptions={categoryOptions}
      selectedOption={getSelectedOptions(categoryOptions, CategoryIds)}
      setSelectedOptions={(values) => {
        onChange(
          'CategoryIds',
          values?.map((option) => Number(option.value))
        );
      }}
      disabled={disabled}
    />
    <MultipleSelect
      className={`${FILTER}_select`}
      placeholder="Все бренды"
      allOptions={brandsOptions}
      selectedOption={getSelectedOptions(brandsOptions, BrandIds)}
      setSelectedOptions={(values) =>
        onChange(
          'BrandIds',
          values?.map((option) => Number(option.value))
        )
      }
      disabled={disabled}
    />

    <Select
      className={`${FILTER}_select`}
      placeholder="Нужно выбрать склад"
      options={warehousesOptions}
      value={WarehouseId ?? null}
      onChange={(value) => onChange('WarehouseId', value)}
      disabled={disabled}
      showSearch
      optionFilterProp="label"
      maxTagCount="responsive"
      filterOption={(input, option) => {
        const label = String(option?.label ?? '');
        return label.toLowerCase().includes(input.toLowerCase());
      }}
    />

    <div className={`${FILTER}_range`}>
      <Range
        label="Цена"
        values={{ from: PriceOfSaleS, to: PriceOfSaleE }}
        onChange={({ from, to }) => {
          onChange('PriceOfSaleS', from ?? null);
          onChange('PriceOfSaleE', to ?? null);
        }}
        disabled={disabled}
        min={0}
        max={CLIENT_BALANCE_MAX}
        inputsClassName={`${FILTER}_range-inputs`}
        labelClassName={`${FILTER}_range-label`}
      />
    </div>

    <div className={`${FILTER}_range`}>
      <Range
        label="Цена закупки"
        values={{ from: PriceOfPurchaseS, to: PriceOfPurchaseE }}
        onChange={({ from, to }) => {
          onChange('PriceOfPurchaseS', from ?? null);
          onChange('PriceOfPurchaseE', to ?? null);
        }}
        disabled={disabled}
        min={0}
        inputsClassName={`${FILTER}_range-inputs`}
        labelClassName={`${FILTER}_range-label`}
      />
    </div>
    <div className={`${FILTER}_checkboxes`}>
      <Checkbox
        checked={Boolean(IsAtMinimal)}
        onChange={(event) => onChange('IsAtMinimal', event.target.checked)}
        disabled={disabled}
      >
        Ниже минимального остатка
      </Checkbox>
      <Checkbox
        checked={Boolean(IsAtCritical)}
        onChange={(event) => onChange('IsAtCritical', event.target.checked)}
        disabled={disabled}
      >
        Ниже критического остатка
      </Checkbox>
    </div>

    <div className={`${FILTER}_buttons`}>
      <Button
        htmlType="reset"
        onClick={skipFilters}
        className={`${FILTER}_buttons_item`}
      >
        <CloseCircleOutlined />
        Сброс
      </Button>
      <Button
        type="primary"
        onClick={onSearch}
        className={`${FILTER}_buttons_item`}
      >
        Показать
      </Button>
    </div>
  </div>
);
